<div style="height: 20vh" class="d-flex justify-content-center align-items-center">
    <mat-spinner diameter="45"></mat-spinner>
</div>